import React, { Component, Fragment } from 'react'
import { Button, message, Modal } from 'antd'
import DiscountButton from 'Components/DiscountButton'
import EditRowModalAgreement from 'Components/EditRowModalAgreement'
import { AlignRightColumn, WhiteTable } from 'Common/styled'
import * as _ from 'lodash'
import { numeral } from 'Common/global'

import { agreementState, formats, refsTableLocale, userType } from 'Common/constants'


class SelectedRefsTable extends Component {


  baseColumns = [
    {
      title: 'Ref. LM',
      dataIndex: 'refLm',
      key: 'refLm'
    },
    {
      title: 'Descrizione',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: 'Gamma',
      dataIndex: 'gamma',
      key: 'gamma'
    },
    {
      title: 'N. negozi',
      dataIndex: 'storesNumber',
      key: 'storesNumber',
      render: value => {
        return numeral(value).format(formats.int);
      }
    }
  ];
  maxQuantityCol = {
    title: 'Qtà stock',
    dataIndex: 'maxQuantity',
    key: 'maxQuantity',
    render: value => {
      return numeral(value).format(formats.number);
    }
  };
  proposedQuantityCol = {
    title: 'Qtà proposta',
    dataIndex: 'proposedQuantity',
    key: 'proposedQuantity',
    className:
      this.props.editable &&
      this.props.user.type === userType.PM.key && this.props.user.type === userType.AM.key &&
      'editable-col',
    render: value => {
      return numeral(value).format(formats.number);
    }
  };
  acceptedQuantityCol = {
    title: 'Qtà accettata',
    dataIndex: 'acceptedQuantity',
    key: 'acceptedQuantity',
    className:
      this.props.editable &&
      this.props.user.type === userType.S.key &&
      'editable-col',
    render: value => {
      return numeral(value).format(formats.number);
    }
  };
  priceCol = {
    title: 'Prezzo',
    dataIndex: 'price',
    key: 'price',
    render: value => {
      return numeral(value).format(formats.currency);
    }
  }
  discountCol = {
    title: '% di sconto',
    dataIndex: 'discount',
    key: 'discount',
    className: this.props.editable && 'editable-col',
    render: value => {
      return numeral(value / 100).format(formats.percentage);
    }
  };
  proposedPriceCol = {
    title: 'Prezzo proposto',
    dataIndex: 'proposedPrice',
    key: 'proposedPrice',
    className:
      this.props.editable &&
      this.props.user.type === userType.PM.key && this.props.user.type === userType.AM.key &&
      'editable-col',
    render: value => {
      return numeral(value).format(formats.currency);
    }
  };
  acceptedPriceCol = {
    title: 'Prezzo accettato',
    dataIndex: 'acceptedPrice',
    key: 'acceptedPrice',
    className:
      this.props.editable &&
      this.props.user.type === userType.S.key &&
      'editable-col',
    render: value => {
      return numeral(value).format(formats.currency);
    }
  };
  totalAmountCol = {
    title: 'Totale',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    render: value => {
      return numeral(value).format(formats.currency);
    }
  };
  actionsCol = {
    key: 'actions',
    render: record =>
      this.props.editable && (
        <Button
          icon="edit"
          type="primary"
          title="Modifica"
          onClick={() => this.editRow(record)}
        />
      )
  };

  pmColumnsList = [
    ...this.baseColumns,
    this.maxQuantityCol,
    this.proposedQuantityCol,
    this.priceCol,
    this.discountCol,
    this.proposedPriceCol,
    this.totalAmountCol,
    this.actionsCol
  ]
  supplierColumnsList = [
    ...this.baseColumns,
    this.maxQuantityCol,
    this.proposedQuantityCol,
    this.acceptedQuantityCol,
    this.priceCol,
    this.discountCol,
    this.proposedPriceCol,
    this.acceptedPriceCol,
    this.totalAmountCol,
    this.actionsCol
  ]
  amColumnsList = [
    ...this.baseColumns,
    this.maxQuantityCol,
    this.proposedQuantityCol,
    this.priceCol,
    this.discountCol,
    this.proposedPriceCol,
    this.totalAmountCol,
    this.actionsCol
  ]

  buildColumnsList = () => {
    const { user, data } = this.props
    // build columns list based on user type and agreement state
    if (user.type === userType.PM.key) {
      return data.agreementState !== agreementState[0].key &&
      data.agreementState !== agreementState[1].key
        ? this.supplierColumnsList
        : this.pmColumnsList
    } else if (user.type === userType.S.key) {
      return this.supplierColumnsList
    } else if (user.type === userType.AM.key) {
      const columnList = data.agreementState !== agreementState[0].key && data.agreementState !== agreementState[1].key ? this.supplierColumnsList : this.amColumnsList;
      return _.filter(columnList, o => o.key !== 'storesNumber');
    } else {
      if(!this.props.editable) {
        return this.supplierColumnsList
      }
    }
  }

  editRow = entityRow => {
   const { user, isNewAgreement, stores } = this.props
    const row = Object.assign({}, entityRow);
    // Edit row button opens a modal
    Modal.confirm({
      icon: '',
      okText: 'Conferma',
      width: '550px',
      cancelText: 'Annulla',
      content: <EditRowModalAgreement row={row} user={user} isNewAgreement={isNewAgreement} stores={stores} />,
      onOk: () => {
        return new Promise((resolve, reject) => {
          const errorConnections = [];

          if (user.type === userType.PM.key || user.type === userType.AM.key) {
            const proposedQuantities = document.getElementsByClassName('proposedQuantityField')
            const proposedQuantitiesObj = {}
            const proposedPrice = Number(_.get(document.getElementById('proposedPriceField'), 'value', 0))
            let discount = Number(_.get(document.getElementById('discountField'), 'value', 0))
            discount = discount > 100 ? 100 : discount

            row.proposedPrice = Math.abs(proposedPrice)
            row.discount = discount

            _.forEach(proposedQuantities, proposedQuantity => {
              proposedQuantitiesObj[proposedQuantity.getAttribute('data-store-id')] = Number(proposedQuantity.value)
            })

            row.proposedQuantity = 0

            if (Array.isArray(row.connections)) {
              for (let connection of row.connections) {
                let quantity = Number(_.get(proposedQuantitiesObj, connection.storeId, NaN))

                if (_.isNil(quantity) || _.isNaN(quantity)) {
                  continue;
                }

                if (
                  quantity > 2000
                ) {
                  errorConnections.push(connection);
                  continue;
                }

                const target = document.getElementById(`QuantityField-${connection.storeId}`);

                if (!_.isNil(target)) {
                  target.classList.remove('error-field');
                }

                connection.proposedStock = quantity

                row.proposedQuantity += quantity
              }
            }

            if (_.size(errorConnections) > 0) {
              for (let errorConnection of errorConnections) {
                const target = document.getElementById(`QuantityField-${errorConnection.storeId}`);

                if (_.isNil(target)) {
                  continue;
                }

                target.classList.add('error-field');
              }

              message.warning(`Le quantità inserite superano le quantità stock di alcuni negozi.`)
              reject();
              return;
            }

            row.totalAmount = numeral(numeral(row.proposedPrice * row.proposedQuantity).format(formats.currency)).value()
          } else {
            const acceptedQuantities = document.getElementsByClassName('acceptedQuantityField')
            const acceptedQuantitiesObj = {}
            let discount = Number(_.get(document.getElementById('discountField'), 'value', 0))
            discount = discount > 100 ? 100 : discount

            row.discount = discount
            row.acceptedPrice = Math.abs(Number(_.get(document.getElementById('acceptedPriceField'), 'value', 0)))

            _.forEach(acceptedQuantities, acceptedQuantity => {
              acceptedQuantitiesObj[acceptedQuantity.getAttribute('data-store-id')] = Number(acceptedQuantity.value)
            })

            row.acceptedQuantity = 0

            if (Array.isArray(row.connections)) {
              for (let connection of row.connections) {
                let quantity = Number(_.get(acceptedQuantitiesObj, connection.storeId, NaN))

                if (_.isNil(quantity) || _.isNaN(quantity)) {
                  continue;
                }

                if (quantity > connection.storeStock) {
                  errorConnections.push(connection);
                  continue;
                }

                const target = document.getElementById(`QuantityField-${connection.storeId}`);

                if (!_.isNil(target)) {
                  target.classList.remove('error-field');
                }

                connection.acceptedStock = quantity

                row.acceptedQuantity += quantity
              }
            }

            if (_.size(errorConnections) > 0) {
              for (let errorConnection of errorConnections) {
                const target = document.getElementById(`QuantityField-${errorConnection.storeId}`);

                if (_.isNil(target)) {
                  continue;
                }

                target.classList.add('error-field');
              }

              message.warning(`Le quantità inserite superano le quantità stock di alcuni negozi.`)
              reject();
              return;
            }

            row.totalAmount = numeral(numeral(row.acceptedPrice * row.acceptedQuantity).format(formats.currency)).value()
          }

          this.handleSave(row)
          resolve();
        })
      }
    })
  }

  handleSave = row => {
    // Overwrite row with new data
    const newData = this.props.data.agreementDetails.slice();
    const index = newData.findIndex(item => row.refLm === item.refLm)
    const item = newData[index]
    newData.splice(index, 1, {
      ...item,
      ...row
    })
    // Save updated row on Redux store
    this.props.onChangeCallback({ agreementDetails: newData })
  }

  applyDiscount = discount => {
    // For each selected row
    const newData = this.props.data.agreementDetails.map(e => {
      const currentRole = _.get(this.props, ['user', 'type'], null);
      e.discount = numeral(numeral(discount).format(formats.percentage)).value();
      if (!!([userType.PM.key, userType.AM.key].indexOf(currentRole) > -1)) {
        e.proposedPrice = e.price * (1 - (e.discount / 100))
        e.totalAmount = numeral(numeral(e.proposedPrice * e.proposedQuantity).format(formats.currency)).value();
      } else {
        e.acceptedPrice = e.price * (1 - (e.discount / 100))
        e.totalAmount = numeral(numeral(e.acceptedPrice * e.acceptedQuantity).format(formats.currency)).value();
      }
      return e
    })
    // Save updated rows on Redux store
    this.props.onChangeCallback({ agreementDetails: newData })
  }

  renderTotalAmount = () => {
    // Calculate sum of totalAmount column (to render it in the table footer)
    const refs = this.props.data.agreementDetails
    let sum = 0
    refs.forEach((e, i) => {
      sum += parseFloat(e.totalAmount)
    })
    return numeral(sum).format(formats.currency);
  }

  render() {
    const { data, editable } = this.props
    return (
      <Fragment>
        {editable && (
          <AlignRightColumn>
            <DiscountButton
              applyDiscountCallback={this.applyDiscount}
              disabled={!data.agreementDetails}
            />
          </AlignRightColumn>
        )}
        <WhiteTable
          locale={refsTableLocale}
          dataSource={data.agreementDetails}
          columns={this.buildColumnsList()}
          size="small"
          rowKey={record => record.refLm}
          footer={() => (
             <AlignRightColumn>
               Totale: {data.agreementDetails ? this.renderTotalAmount() : numeral(0).format(formats.currency)}
             </AlignRightColumn>
          )}
        />
      </Fragment>
    )
  }
}

export default SelectedRefsTable



// WEBPACK FOOTER //
// ./src/components/SelectedRefsTable/index.js